import React from 'react'
import styled, { css } from 'styled-components'
import { BodyCopy, H2 } from './Typography'
import media from 'css-in-js-media'

export const StyledTitle = styled.div`
    margin-left: auto;
    margin-right: auto;
    max-width: ${(props) => `${props.titleWidth}px` || '100%'};

    ${(props) =>
        !props.noMargin &&
        !props.noMarginTop &&
        !props.noMarginBottom &&
        css`
            margin-top: 40px;
            margin-bottom: 40px;
            ${media('>=desktop')} {
                margin-top: 80px;
                margin-bottom: 80px;
            }
        `}

    ${(props) =>
        props.noMarginTop == true &&
        css`
            margin-top: 40px;
            ${media('>=desktop')} {
                margin-bottom: 80px;
            }
        `}

    ${(props) =>
        props.noMarginBottom == true &&
        css`
            margin-top: 40px;
            ${media('>=desktop')} {
                margin-top: 80px;
            }
        `}

    ${BodyCopy} {
        font-weight: 500;
        font-size: 16px;
        line-height: 160%;
        letter-spacing: 0.005em;
        margin-top: 20px;
    }

    ${(props) =>
        props.align == 'left' &&
        css`
            text-align: left;
        `}

    ${(props) =>
        props.align == 'center' &&
        css`
            text-align: center;
        `}
`

const Title = ({ children, ...props }) => {
    return <StyledTitle {...props}>{children}</StyledTitle>
}

export default Title
